// NOTE: in-app feedback goes through the FeedbackModal -> backend API, not a mailto. These
// constants are a fallback contact only. (Was beta@opticswap.com — a retired identity — until
// 2026-06; pointed at the monitored support mailbox now.)
export const FEEDBACK_EMAIL = "support@opticswap.com";
export const FEEDBACK_MAILTO = `mailto:${FEEDBACK_EMAIL}?subject=${encodeURIComponent("OpticSwap Beta Feedback")}&body=${encodeURIComponent("What worked, what didn't, and what you'd want next:\n\n")}`;
